export enum UserPermission {
	/**Permissions suivant les niveaux hierarchique  */
	IsSuperAdmin = 'IsSuperAdmin',
	IsAdminEmdf = 'IsAdminEmdf',
	IsNiveau1 = 'IsNiveau1',
	IsNiveau2 = 'IsNiveau2',
	IsNiveau3 = 'IsNiveau3',
	IsNiveau4 = 'IsNiveau4',
	IsRB = 'IsRB',
	IsFichierAvocat = 'IsFichierAvocat',
	IsAvocat = 'IsAvocat',
	IsPlacements = 'IsPlacements',
	// Can view "natures d'affaires" list
	ViewAllNaturesAffaire = 'Affaire.Nature.CanView',

	// Can create / update / delete "natures d'affaires"
	ManageNaturesAffaires = 'Affaire.Nature.CanManage',

	// Can view "qualités de tiers" list
	ViewAllQualitesTiers = 'QualiteTier.CanView',

	// Can create / update / delete "qualités de tiers"
	ManageQualitesTiers = 'QualiteTier.CanManage',

	// Can view "types d'opérations" list
	ViewAllTypesOperation = 'Operation.Type.CanView',

	// Can view "types d'opérations" list
	ViewCarpaTypesOperation = 'Operation.Type.Carpa.CanView',

	// Can create / update / delete "type d'opération"
	ManageTypesOperation = 'Operation.Type.CanManage',

	// Can create / update / delete "type d'opération" Carpa
	ManageTypesOperationCarpa = 'Operation.Type.Carpa.CanManage',

	// Can view "natures d'opérations" list
	ViewAllNaturesOperation = 'Operation.Nature.CanView',
	// Can view "natures d'opérations" list
	ViewCarpaNaturesOperation = 'Operation.Nature.Carpa.CanView',

	// Can manage common fields of "nature d'opération" list
	ManageNaturesOperation = 'Operation.Nature.CanManage',

	// Can manage carpa fields of "nature d'opération" list
	ManageNaturesOperationCarpa = 'Operation.Nature.Carpa.CanManage',

	// Can search "affaires"
	ViewAffaires = 'Affaire.CanView',

	// Can view "dépôts" list
	ViewDepots = 'Depot.CanView',

	// Can only delete own depots enregistre
	DeleteMesDepotsEnregistres = 'Depot.MesDepotsEnregistres.CanDelete',

	// Can only update own depots enregistre
	UpdateDepotsEnregistres = 'Depot.Enregistre.CanUpdate',

	// Can only update own depots enregistre
	UpdateMesDepotsEnregistres = 'Depot.MesDepotsEnregistres.CanUpdate',

	AccepterOperation = 'Operation.CanAccept',

	ValiderOperation = 'Operation.CanValidate',

	RefuserOperation = 'Operation.CanRefuse',

	AutoAffectOperation = 'Operation.CanAutoAffect',

	RefuserDemandesRibEnregistre = 'DemandeRib.Enregistre.CanRefuse',

	CreateDemandeRib = 'DemandeRib.CanCreate',

	UpdateDemandeRib = 'DemandeRib.CanUpdate',

	CreateDepot = 'Depot.CanCreate',

	UpdateDepot = 'Depot.UpdateDepot',

	CreateRetrait = 'Retrait.CanCreate',

	UpdateRetrait = 'Retrait.CanUpdate',

	UpdateBlockAffaire = 'Affaire.Blocked.CanUpdate',

	CreateAffaire = 'Affaire.CanCreate',

	UpdateAffaire = 'Affaire.CanUpdate',

	AffaireeCanUnarchive = 'Affaire.CanUnarchive',

	AffaireeCanArchive = 'Affaire.CanArchive',

	UpdateDemandesRibEnAttente = 'DemandeRib.EnAttente.CanUpdate',

	UpdateDepotsEnAttente = 'Depot.EnAttente.CanUpdate',

	UpdateRetraitsEnAttente = 'Retrait.EnAttente.CanUpdate',

	ViewAllOperationsTraitement = 'Operation.Traitement.All.CanView',

	ViewMesOperations = 'Affaire.MesOperations.CanView',

	ViewOperationsEnregistrees = 'Operation.Enregistre.CanView',

	//Can manage virement reçu : view/create/validate
	ManageVirementRecu = 'VirementRecu.CanManage',

	AffectVirementRecu = 'VirementRecu.CanAffect',

	AffectVirementRecuTo = 'VirementRecu.To.CanAffect',

	AffectVirementRecuToAll = 'VirementRecu.ToAll.CanAffect',

	UpdateOperationVirementRecu = 'Operation.VirementRecu.CanUpdate',

	AccepterOperationTraitement = 'Operation.Traitement.CanAccept',

	UseAllTraitementFilters = 'Operation.Traitement.All.CanFilter',

	ViewOperationsAValider = 'Operation.AValider.CanView',

	GenerateLots = 'Lot.CanGenerate',
	ViewLots = 'Lot.CanView',
	DeleteLots = 'Lot.CanDelete',
	DeleteLotsPlacement = 'LotPlacement.CanDelete',
	DeleteLotOperation = 'Lot.Operation.CanDelete',
	ManageLotDocuement = 'Lot.Document.CanManage',

	CreateCarpa = 'Carpa.CanCreate',
	ViewCarpa = 'Carpa.CanView',

	SemaphoreCanManage = 'Carpa.Semaphore.CanManage',
	
	UpdateCarpa = 'Carpa.CanUpdate',
	UpdateMyCarpa = 'Carpa.CanUpdateMyCarpa', // Modifier uniquement sa propre carpa (Admin CARPA)
	ManageCarpa = 'Carpa.CanManage', // Ajout, modif et suppression

	ManageBarreaux = 'Barreau.CanManage',
	UpdateMyBarreau = 'Barreau.CanUpdateMyBarreau', // Modifier uniquement les barreaux de sa CARPA (Admin CARPA)

	UploadIntegrationBancaire = 'IntegrationBancaire.CanUpload',

	ViewIntegrationBancaireStatut = 'IntegrationBancaire.Statut.CanView',

	FiltrerOperationsEnregistreesParUtilisateur = 'Operation.EnregistreesParUtilisateur.CanFilter',

	ViewOperationsTraitement = 'Operation.Traitement.CanView',

	//Can create / update / delete pays
	ManagePays = 'Pays.CanManage',

	//can consult pays
	ViewPays = 'Pays.CanView',

	//Can create / update / delete devise
	ManageDevises = 'Devise.CanManage',

	//can consult devise
	ViewDevises = 'Devise.CanView',

	//Can create / update / delete receptions modes
	ManageModesReception = 'ModeReception.CanManage',

	//Can view receptions modes commun
	ViewModesReceptionCommon = 'ModeReception.Common.CanView',

	//Can view specifics receptions modes
	ViewModesReceptionSpecifique = 'ModeReception.Specifique.CanView',

	//Can set default mode of reception
	SetModeReceptionParDefaut = 'ModeReception.Default.CanCreate',

	// can scan bordereau
	ScanBordereau = 'Affaire.Bordereau.CanScan',

	//Can create / update / delete  Codes Interbancaires
	ManageCodesinterbancaires = 'CodeInterbancaire.CanManage',

	//can consult Codes Interbancaires
	ViewCodesInterbancaires = 'CodeInterbancaire.CanView',

	//can manage liasses de cheques
	ManageLiasseCheque = 'Cheque.Liasse.CanManage',

	//can delete rapprochement
	DeleteRapprochement = 'Rapprochement.Bancaire.CanDelete',
	RapprochementBancaire = 'IsRB',

	ViewDetailsOperation = 'Operation.Details.CanView',
	//can Regenerate Lot Xml File
	RegenerateLotXmlFile = 'Lot.XmlFile.CanGenerate',
	RegenerateLotPlacementXmlFile = 'LotPlacement.XmlFile.CanGenerate',
	//can view popin ecart balance
	AffaireBalanceCanView = 'Affaire.Balance.CanView',

	//Can view / create / delete CarpaDelegation
	ManageCarpaDelegation = 'Carpa.Delegation.CanManage',

	//Can create / delete CarpaDocument
	ManageCarpaDocument = 'Carpa.Document.CanManage',
	//Can view CarpaDocument
	ViewCarpaDocument = 'Carpa.Document.CanView',

	// can manage utilisateurs
	ManageUtilisateurs = 'Utilisateur.CanManage',

	// Can manage / create Compte
	OuvrirCompte = 'Compte.CanCreate',

	// Can manage / create Compte
	CompteCanClose = 'Compte.CanClose',

	//Can Change SaisieEnMass
	CompteChangeSaisieEnMasse = 'Compte.CanChangeSaisieEnMasse',

	// can manage signatures
	ManageSignatures = 'Structure.Signature.CanManage',

	// can annuler cheque
	AnnulerCheque = 'Cheque.CanCancel',
	AnnulerChequeEnCoursCloture = 'Cheque.CanCancelEnCoursCloture',

	// can delete annulation cheque
	SupprimerAnnulationCheque = 'Cheque.Annulation.CanDelete',

	//can transfer operationn from Affaire A to Affaire B
	TransfertOperations = 'Operation.CanTransfer',

	// can transfer affaires From Compte A to Compte B
	AffaireTransfert = 'Affaire.CanTransfer',

	// Can make an affaire in progress of treatment
	AffaireFlag = 'Affaire.CanFlag',

	//Can manage evenement : consult and mark as treated
	EvenementCanManage = 'Evenement.CanManage',

	//Can manage "Modeles des documents" : Add, Edit, Delete
	ModeleDocumentCanManage = 'ModeleDocument.CanManage',

	// Can Reject Operation
	RejectOperation = 'Operation.CanReject',
	RejectOperationEnCoursCloture ='Operation.CanRejectEnCoursCloture',
	
	// Can Unpaid Operation
	UnpaidOperation = 'Operation.CanUnpaid',
	UnpaidOperationEnCoursCloture = 'Operation.CanUnpaidEnCoursCloture',

	// Logs
	LogCanManage = 'Log.CanManage',
	LogCanView = 'Log.CanView',

	// HealthChecks
	HealthChecksCanView = 'HealthChecks.CanView',

	// Statistiques
	StatistiqueCanRun = 'Statistique.CanRun',
	StatistiqueAllCanView = 'Statistique.All.CanView',
	StatistiqueCanRunAllTenant = 'Statistique.CanRunAllTenant',
	StatistiqueCanTest = 'Statistique.CanTest',
	StatistiqueCanView = 'Statistique.CanView',
	StatistiqueCanManage = 'Statistique.CanManage',
	StatistiqueParametresCanManage = 'Statistique.Parametres.CanManage',
	StatistiqueOngletStatistiquesCanView = 'Statistique.OngletStatistiques.CanView',
	StatistiqueOngletCDCCCanView = 'Statistique.OngletCDCC.CanView',
	StatistiqueOngletN4CanView = 'Statistique.OngletN4.CanView',

	//Can manage "Libelles à controller" : View, Add, Edit, Delete
	LibellesAControlerCarpaCanView = 'LibellesAControler.Carpa.CanView',
	LibellesAControlerGeneriqueCanView = 'LibellesAControler.Generique.CanView',
	ElementsAControlerCanAlerte = 'ElementsAControler.CanAlerte',
	LibellesAControlerCarpaCanUpdate = 'LibellesAControler.Carpa.CanUpdate',
	LibellesAControlerGeneriqueCanUpdate = 'LibellesAControler.Generique.CanUpdate',
	RolesCanView = 'Roles.CanView',
	RolesPermissionsCanView = 'RolesPermissions.CanView',

	//Can view paramétres
	ParametresCanView = 'Parameters.CanView',

	/** Permission Menu*/

	//Pouvoir Acceder au menu Paramètrage
	ParamertageMenuCanAccess = 'menu.Parametrages.canAccess',

	//Droit Access Menu Gestion Avocat
	GestionAvocatMenuCanAccess = 'menu.GestionAvocat.canAccess',

	//Droit Access Menu Log
	LogMenuCanAccess = 'menu.Log.canAccess',

	/** Permissions Paramètrages Type Opération*/

	//Can update Date Valeur
	DateValeurTypeOperationCanUpdate = 'TypeCredit.CanUpdateDateValeur',
	//Can save type de credit
	TypeCreditCanSave = 'TypeCredit.CanSavePlacement',

	//Enable LibelleECarpa
	TypeCreditEnableLibelleECarpa = 'TypeCredit.EnableLibelleECarpa',

	//Option Comportement Specifiques
	OptionComportementSpecifiques = 'TypeCredit.OptionComportementSpecifiques',

	// Suppression des opérations: Voir US 8039
	OperationEnregistreEtEtatsAvantCanDelete = 'Operation.EnregistreEtEtatsAvant.CanDelete',
	OperationValidesCanDelete = 'Operation.Valides.CanDelete',

	/* Permissions sur les APRs */
	AprCanManage = 'Apr.CanManage',
	AprNiveauDeuxCanManage = 'Apr.NiveauDeux.CanManage',

	/* Permissions sur les transferts compte spécial */
	OperationA15CanManage = 'Operation.A15.CanManage',
	OperationVECanManage = 'Operation.VE.CanManage',

	/* Permissions sur l'affectation des opérations à valider */
	OperationAValiderCanAffect = 'Operation.AValider.CanAffect',

	/* Permissions sur la saisie en masse */
	CompteCanChangeSaisieEnMasse = 'Compte.CanChangeSaisieEnMasse',

	// Permissions sur le popin import en masse
	CompteCanImportFileSaisieEnMasse = 'Compte.CanImportFileSaisieEnMasse',

	/** Permissions Fonds Indisponibles*/
	FondsIndisponiblesCanAccess = 'FondsIndisponibles.CanAccess',

	/**Permissions sur le blocage et deblocage  */
	LockCompte = 'Compte.CanLock',
	LockAffaire = 'Affaire.CanLock',
	LockOperation = 'Operation.CanLock',
	UnlockCompte = 'Compte.CanUnlock',
	UnlockAffaire = 'Affaire.CanUnlock',
	UnlockOperation = 'Operation.CanUnlock',

	SetOngoing = 'Affaire.CanSetOngoing',

	/** Permission de renvoi des opérations */
	ResendOperation = 'Operation.CanResend',

	/** Permission de modification une opération validée ou generée ou rapproche*/
	OperationValideeCanUpdate = 'Operation.Valide.CanUpdate',

	AffaireCommentaireCanCreate = 'Affaire.Commentaire.CanCreate',
	AffaireCommentaireCanView = 'Affaire.Commentaire.CanView',
	AffaireDocumentCanUpload = 'Affaire.Document.CanUpload',
	AffaireDocumentCanView = 'Affaire.Document.CanView',

	CompteCommentaireCanCreate = 'Compte.Commentaire.CanCreate',
	CompteCommentaireCanView = 'Compte.Commentaire.CanView',
	CompteDocumentCanUpload = 'Compte.Document.CanUpload',
	CompteDocumentCanView = 'Compte.Document.CanView',

	OperationCommentaireCanCreate = 'Operation.Commentaire.CanCreate',
	OperationCommentaireCanView = 'Operation.Commentaire.CanView',
	OperationDocumentCanUpload = 'Operation.Document.CanUpload',
	OperationDocumentCanView = 'Operation.Document.CanView',
	OperationDocumentAutreUtilisateurCanDelete = 'Operation.Document.AutreUtilisateur.CanDelete',

	DocumentCanDelete = 'Document.CanDelete',

	// Banque Permission
	BanqueCanView = 'Banque.CanView',
	BanqueCanCreate = 'Banque.CanManag',
	BanqueCanTestConnexion = 'Banque.Connexion.CanTest',

	// gestion type APR
	GestionTypeAprCanView = 'ApprocheParRisque.GestionTypeApr.CanView',
	GestionTypeAprCanManage = 'ApprocheParRisque.GestionTypeApr.CanManage',

	// IbanFrauduleux
	IbanFrauduleuxCanAlerte = 'IbanFrauduleux.CanAlerte',
	IbanFrauduleuxGeneriqueCanView = 'IbanFrauduleux.Generique.CanView',
	IbanFrauduleuxGeneriqueCanManage = 'IbanFrauduleux.Generique.CanManage',

	//DelegationBancaire
	DelegationBancaireCanManage = 'DelegationBancaire.CanManage',

	// Page de maintenance
	MaintenancePageCanManage = 'MaintenancePage.CanManage',

	// Message
	MessageCanManage = 'Message.CanManage',

	//ibanVirtuel
	IbanVirtuelCanManage = 'Banque.IbanVirtuel.CanManage',

	//fiche tier
	TiersCanUpdate = 'Tiers.CanUpdate',

	// RBE
	RbeCanview = 'Rbe.CanView',

	// version
	VersionCanView = 'Version.CanView',
 
	//commentaires
	CanViewCommentaires = 'Commentaires.CanView',
	CanDeleteCommentaires = 'Commentaires.CanDelete',

	//instructions permanentes
	CanCreateInstructionPermanente ="InstructionPermanente.CanCreate",

	// replay historique opération
	ReplayOperationHistory = 'Operation.CanReplayHistory',

}
